import { Component } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-mobile-option-details',
  templateUrl: './skeleton-mobile-option-details.component.html',
})
export class SkeletonMobileOptionDetailsComponent {
  constructor() {}
}
